import styles from '../../HomepageSections.module.scss';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
}

export const SectionHeading = ({ eyebrow, title, description }: SectionHeadingProps) => (
  <div className={styles.heading}>
    <span className={styles.eyebrow}>{eyebrow}</span>
    <h2>
      {title}
      <b>.</b>
    </h2>
    {description && <p>{description}</p>}
  </div>
);
